module.exports = __webpack_public_path__ + "img/110.5236c2b8.jpg";